'use client';

import { createContext, PropsWithChildren, useContext } from 'react';

type Values = {
  isApplePaySupportedByBrowser: boolean;
  isGooglePaySupportedByBrowser: boolean;
  isIosOs: boolean;
  abGroup: string;
  hasRememberMeCookie?: boolean;
  isAppleDevice?: boolean;
};

const Context = createContext<Values>({
  isApplePaySupportedByBrowser: false,
  isGooglePaySupportedByBrowser: false,
  isIosOs: false,
  abGroup: '',
  hasRememberMeCookie: false,
  isAppleDevice: false,
});

export const ConfigProvider = ({ children, ...contextValue }: PropsWithChildren<Values>) => {
  return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};

export const useConfigContext = () => {
  return useContext(Context);
};

export const useAbGroup = () => {
  return useConfigContext().abGroup;
};

export const useIsIosOs = () => {
  return useConfigContext().isIosOs;
};

export const useHasRememberMeCookie = () => {
  return useConfigContext().hasRememberMeCookie;
};
